// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Permission_invalidDataError__bkudj"};